import { render, staticRenderFns } from "./Archie.vue?vue&type=template&id=6e1d2e02"
import script from "./Archie.vue?vue&type=script&lang=js"
export * from "./Archie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports